import { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { moduleActions } from '../../redux/modules';
import { isSalesforceRep } from '../../redux/modules/authentication/authentication.module.selectors';
import MailCheck from '../../components/MailACheck/MailCheck';
export const MailCheckContainer = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      dispatch({
        type: 'APP_LOADED_FULFILLED',
        payload: true,
      });
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <MailCheck />;
};
export const mapStateToProps = (state) => {
  const { authentication, applicationData } = state;
  return {
    isSalesforceRep: isSalesforceRep(state),
    authentication,
    applicationData,
  };
};
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
});
export default compose(connect(mapStateToProps, mapDispatchToProps))(
  MailCheckContainer
);
